import { Dialog, styled } from '@mui/material';

const StyledDialog = styled(Dialog)`
  max-height: 80%;
  margin-top: 4rem;
`;

export default StyledDialog;
